
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta } from "/app/app/pages/index.vue?macro=true";
import { default as searchJXPZ_UVhNYbjpivzKjpGCvUJkkOqGgpNEOaF3qx_C_EMeta } from "/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/search.vue?macro=true";
import { default as indexAM6HA6ylPlvG7md4_cTIgloZ_eJJIDe6WCNhIMdLVooMeta } from "/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/user-zone/index.vue?macro=true";
import { default as profileDo1_NBLIjkl8BqRLJmm0j7SrI66P2r0GoGmEntWbuJUMeta } from "/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/user-zone/profile.vue?macro=true";
import { default as bookings4GiKl5es3TyPcFP1dFF5aR2oEpCElQHedpxOjnOZsuAMeta } from "/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/user-zone/bookings.vue?macro=true";
import { default as favoriteseF2lOtqT0JqBicmIZfqPfmOL3i95wHBQWd1F1vvWOx4Meta } from "/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/user-zone/favorites.vue?macro=true";
import { default as user_45zonej1vDEkDMxnsA4MXQtRGPP1pCwxeZYYzvLaGgbq10LqoMeta } from "/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/user-zone.vue?macro=true";
import { default as destinationsXUFxzZFmnVKH_a7aUaIEEyN8hSoae97x7RNATzmluG4Meta } from "/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/destinations.vue?macro=true";
import { default as loginHHIJ9Isgs9f9zSVyzIy_cQtV9V10oEhwpzu5soyB8L8Meta } from "/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(login)/login.vue?macro=true";
import { default as recoverpqaR0rd6HYRcEDyP5h7Wc_KlSpsvMhBGI7c0xQYs4z0Meta } from "/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(login)/recover.vue?macro=true";
import { default as registermAxg1Q2G_8ykVAz_nemWQfutuY1Ezx4q0V6xRSSc_pAMeta } from "/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(login)/register.vue?macro=true";
import { default as _91city_93_45_91id_93_46htmlqfF964u0MkbnViDMlSUBmPys0vQXFy5JJQztCC_TXrsMeta } from "/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/[city]-[id].html.vue?macro=true";
import { default as _91hotel_93_45_91id_93_46htmlodheIHEJ9GsNdtpPrwJa21msSRYAb6WEesaq3iM_dAMMeta } from "/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/[hotel]-[id].html.vue?macro=true";
import { default as terms_46html9MyQDMgNtGOHx3rRzHgYpit__Xli8BgJSA92MO8jjGcMeta } from "/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(terms)/terms.html.vue?macro=true";
import { default as como_45funciona_46html91Ug51xMl1GuJ6NTQP0Id9i4vqIkYES9mMon_QN5rZsMeta } from "/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/como-funciona.html.vue?macro=true";
import { default as _91landing_93_45_91id_93_46htmlFjxUHC1u_ivpUYeIGHOY9A8mxmGQ9bH2h1iaotXcRIQMeta } from "/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/[landing]-[id].html.vue?macro=true";
import { default as confirm68nO8wcKwuXAEuUd2tk0KQZ3G9G8zBrgCXMtFhprAGEMeta } from "/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(payment)/v2/confirm.vue?macro=true";
import { default as privacy_46htmlzvKm_xnnuffPPNfT2LZLy59AAvq9JVnotIQC9vF6n6cMeta } from "/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(terms)/privacy.html.vue?macro=true";
import { default as _91hash_939etv2tvGL9NI0gFqKCnRbx7YRujwLt7HbSknAVRJ_zMMeta } from "/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(login)/recover-pass/[hash].vue?macro=true";
import { default as payment_45return4fMY56k_fQusi3dvoSnbOIrgdI_XJ6C6LkJdw3aGJN0Meta } from "/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(payment)/v2/payment-return.vue?macro=true";
import { default as one_45step_45check_45outJVvpgRnVMeYnhMGPCDvoQieNlF9ywuSnBXWCnz6tC6AMeta } from "/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(payment)/v2/one-step-check-out.vue?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta || {},
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    meta: index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta || {},
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta || {},
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    meta: index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta || {},
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    meta: index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta || {},
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: index4nVS2Dd4a5t9zrU2j8coCxsqtPYupm_GEv_2EzeGhJUMeta || {},
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: "search___es",
    path: "/es/search",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/search.vue")
  },
  {
    name: "search___en",
    path: "/en/search",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/search.vue")
  },
  {
    name: "search___de",
    path: "/de/search",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/search.vue")
  },
  {
    name: "search___it",
    path: "/it/search",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/search.vue")
  },
  {
    name: "search___fr",
    path: "/fr/search",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/search.vue")
  },
  {
    name: user_45zonej1vDEkDMxnsA4MXQtRGPP1pCwxeZYYzvLaGgbq10LqoMeta?.name,
    path: "/es/user-zone",
    meta: { ...(user_45zonej1vDEkDMxnsA4MXQtRGPP1pCwxeZYYzvLaGgbq10LqoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/user-zone.vue"),
    children: [
  {
    name: "user-zone___es",
    path: "",
    meta: {"middleware":"redirect-user-zone"},
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/user-zone/index.vue")
  },
  {
    name: "user-zone-profile___es",
    path: "profile",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/user-zone/profile.vue")
  },
  {
    name: "user-zone-bookings___es",
    path: "bookings",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/user-zone/bookings.vue")
  },
  {
    name: "user-zone-favorites___es",
    path: "favorites",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/user-zone/favorites.vue")
  }
]
  },
  {
    name: user_45zonej1vDEkDMxnsA4MXQtRGPP1pCwxeZYYzvLaGgbq10LqoMeta?.name,
    path: "/en/user-zone",
    meta: { ...(user_45zonej1vDEkDMxnsA4MXQtRGPP1pCwxeZYYzvLaGgbq10LqoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/user-zone.vue"),
    children: [
  {
    name: "user-zone___en",
    path: "",
    meta: {"middleware":"redirect-user-zone"},
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/user-zone/index.vue")
  },
  {
    name: "user-zone-profile___en",
    path: "profile",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/user-zone/profile.vue")
  },
  {
    name: "user-zone-bookings___en",
    path: "bookings",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/user-zone/bookings.vue")
  },
  {
    name: "user-zone-favorites___en",
    path: "favorites",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/user-zone/favorites.vue")
  }
]
  },
  {
    name: user_45zonej1vDEkDMxnsA4MXQtRGPP1pCwxeZYYzvLaGgbq10LqoMeta?.name,
    path: "/de/user-zone",
    meta: { ...(user_45zonej1vDEkDMxnsA4MXQtRGPP1pCwxeZYYzvLaGgbq10LqoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/user-zone.vue"),
    children: [
  {
    name: "user-zone___de",
    path: "",
    meta: {"middleware":"redirect-user-zone"},
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/user-zone/index.vue")
  },
  {
    name: "user-zone-profile___de",
    path: "profile",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/user-zone/profile.vue")
  },
  {
    name: "user-zone-bookings___de",
    path: "bookings",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/user-zone/bookings.vue")
  },
  {
    name: "user-zone-favorites___de",
    path: "favorites",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/user-zone/favorites.vue")
  }
]
  },
  {
    name: user_45zonej1vDEkDMxnsA4MXQtRGPP1pCwxeZYYzvLaGgbq10LqoMeta?.name,
    path: "/it/user-zone",
    meta: { ...(user_45zonej1vDEkDMxnsA4MXQtRGPP1pCwxeZYYzvLaGgbq10LqoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/user-zone.vue"),
    children: [
  {
    name: "user-zone___it",
    path: "",
    meta: {"middleware":"redirect-user-zone"},
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/user-zone/index.vue")
  },
  {
    name: "user-zone-profile___it",
    path: "profile",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/user-zone/profile.vue")
  },
  {
    name: "user-zone-bookings___it",
    path: "bookings",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/user-zone/bookings.vue")
  },
  {
    name: "user-zone-favorites___it",
    path: "favorites",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/user-zone/favorites.vue")
  }
]
  },
  {
    name: user_45zonej1vDEkDMxnsA4MXQtRGPP1pCwxeZYYzvLaGgbq10LqoMeta?.name,
    path: "/fr/user-zone",
    meta: { ...(user_45zonej1vDEkDMxnsA4MXQtRGPP1pCwxeZYYzvLaGgbq10LqoMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/user-zone.vue"),
    children: [
  {
    name: "user-zone___fr",
    path: "",
    meta: {"middleware":"redirect-user-zone"},
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/user-zone/index.vue")
  },
  {
    name: "user-zone-profile___fr",
    path: "profile",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/user-zone/profile.vue")
  },
  {
    name: "user-zone-bookings___fr",
    path: "bookings",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/user-zone/bookings.vue")
  },
  {
    name: "user-zone-favorites___fr",
    path: "favorites",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/user-zone/favorites.vue")
  }
]
  },
  {
    name: "destinations___es",
    path: "/es/destinations",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/destinations.vue")
  },
  {
    name: "destinations___en",
    path: "/en/destinations",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/destinations.vue")
  },
  {
    name: "destinations___de",
    path: "/de/destinations",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/destinations.vue")
  },
  {
    name: "destinations___it",
    path: "/it/destinations",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/destinations.vue")
  },
  {
    name: "destinations___fr",
    path: "/fr/destinations",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/destinations.vue")
  },
  {
    name: "login___es",
    path: "/es/login",
    meta: loginHHIJ9Isgs9f9zSVyzIy_cQtV9V10oEhwpzu5soyB8L8Meta || {},
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(login)/login.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    meta: loginHHIJ9Isgs9f9zSVyzIy_cQtV9V10oEhwpzu5soyB8L8Meta || {},
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(login)/login.vue")
  },
  {
    name: "login___de",
    path: "/de/login",
    meta: loginHHIJ9Isgs9f9zSVyzIy_cQtV9V10oEhwpzu5soyB8L8Meta || {},
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(login)/login.vue")
  },
  {
    name: "login___it",
    path: "/it/login",
    meta: loginHHIJ9Isgs9f9zSVyzIy_cQtV9V10oEhwpzu5soyB8L8Meta || {},
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(login)/login.vue")
  },
  {
    name: "login___fr",
    path: "/fr/login",
    meta: loginHHIJ9Isgs9f9zSVyzIy_cQtV9V10oEhwpzu5soyB8L8Meta || {},
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(login)/login.vue")
  },
  {
    name: "recover___es",
    path: "/es/recover",
    meta: recoverpqaR0rd6HYRcEDyP5h7Wc_KlSpsvMhBGI7c0xQYs4z0Meta || {},
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(login)/recover.vue")
  },
  {
    name: "recover___en",
    path: "/en/recover",
    meta: recoverpqaR0rd6HYRcEDyP5h7Wc_KlSpsvMhBGI7c0xQYs4z0Meta || {},
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(login)/recover.vue")
  },
  {
    name: "recover___de",
    path: "/de/recover",
    meta: recoverpqaR0rd6HYRcEDyP5h7Wc_KlSpsvMhBGI7c0xQYs4z0Meta || {},
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(login)/recover.vue")
  },
  {
    name: "recover___it",
    path: "/it/recover",
    meta: recoverpqaR0rd6HYRcEDyP5h7Wc_KlSpsvMhBGI7c0xQYs4z0Meta || {},
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(login)/recover.vue")
  },
  {
    name: "recover___fr",
    path: "/fr/recover",
    meta: recoverpqaR0rd6HYRcEDyP5h7Wc_KlSpsvMhBGI7c0xQYs4z0Meta || {},
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(login)/recover.vue")
  },
  {
    name: "register___es",
    path: "/es/register",
    meta: registermAxg1Q2G_8ykVAz_nemWQfutuY1Ezx4q0V6xRSSc_pAMeta || {},
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(login)/register.vue")
  },
  {
    name: "register___en",
    path: "/en/register",
    meta: registermAxg1Q2G_8ykVAz_nemWQfutuY1Ezx4q0V6xRSSc_pAMeta || {},
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(login)/register.vue")
  },
  {
    name: "register___de",
    path: "/de/register",
    meta: registermAxg1Q2G_8ykVAz_nemWQfutuY1Ezx4q0V6xRSSc_pAMeta || {},
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(login)/register.vue")
  },
  {
    name: "register___it",
    path: "/it/register",
    meta: registermAxg1Q2G_8ykVAz_nemWQfutuY1Ezx4q0V6xRSSc_pAMeta || {},
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(login)/register.vue")
  },
  {
    name: "register___fr",
    path: "/fr/register",
    meta: registermAxg1Q2G_8ykVAz_nemWQfutuY1Ezx4q0V6xRSSc_pAMeta || {},
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(login)/register.vue")
  },
  {
    name: "city-id.html___es",
    path: "/es/:city-:id(\\d+[dn]).html",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/[city]-[id].html.vue")
  },
  {
    name: "city-id.html___en",
    path: "/en/:city-:id(\\d+[dn]).html",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/[city]-[id].html.vue")
  },
  {
    name: "city-id.html___de",
    path: "/de/:city-:id(\\d+[dn]).html",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/[city]-[id].html.vue")
  },
  {
    name: "city-id.html___it",
    path: "/it/:city-:id(\\d+[dn]).html",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/[city]-[id].html.vue")
  },
  {
    name: "city-id.html___fr",
    path: "/fr/:city-:id(\\d+[dn]).html",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/[city]-[id].html.vue")
  },
  {
    name: "hotel-id.html___es",
    path: "/es/:hotel-:id(\\d+).html",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/[hotel]-[id].html.vue")
  },
  {
    name: "hotel-id.html___en",
    path: "/en/:hotel-:id(\\d+).html",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/[hotel]-[id].html.vue")
  },
  {
    name: "hotel-id.html___de",
    path: "/de/:hotel-:id(\\d+).html",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/[hotel]-[id].html.vue")
  },
  {
    name: "hotel-id.html___it",
    path: "/it/:hotel-:id(\\d+).html",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/[hotel]-[id].html.vue")
  },
  {
    name: "hotel-id.html___fr",
    path: "/fr/:hotel-:id(\\d+).html",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/[hotel]-[id].html.vue")
  },
  {
    name: "terms.html___es",
    path: "/es/terms.html",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(terms)/terms.html.vue")
  },
  {
    name: "terms.html___en",
    path: "/en/terms.html",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(terms)/terms.html.vue")
  },
  {
    name: "terms.html___de",
    path: "/de/terms.html",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(terms)/terms.html.vue")
  },
  {
    name: "terms.html___it",
    path: "/it/terms.html",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(terms)/terms.html.vue")
  },
  {
    name: "terms.html___fr",
    path: "/fr/terms.html",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(terms)/terms.html.vue")
  },
  {
    name: "como-funciona.html___es",
    path: "/es/como-funciona.html",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/como-funciona.html.vue")
  },
  {
    name: "como-funciona.html___en",
    path: "/en/como-funciona.html",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/como-funciona.html.vue")
  },
  {
    name: "como-funciona.html___de",
    path: "/de/como-funciona.html",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/como-funciona.html.vue")
  },
  {
    name: "como-funciona.html___it",
    path: "/it/como-funciona.html",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/como-funciona.html.vue")
  },
  {
    name: "como-funciona.html___fr",
    path: "/fr/como-funciona.html",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/como-funciona.html.vue")
  },
  {
    name: "landing-id.html___es",
    path: "/es/:slug-:id(\\d+l).html",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/[landing]-[id].html.vue")
  },
  {
    name: "landing-id.html___en",
    path: "/en/:slug-:id(\\d+l).html",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/[landing]-[id].html.vue")
  },
  {
    name: "landing-id.html___de",
    path: "/de/:slug-:id(\\d+l).html",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/[landing]-[id].html.vue")
  },
  {
    name: "landing-id.html___it",
    path: "/it/:slug-:id(\\d+l).html",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/[landing]-[id].html.vue")
  },
  {
    name: "landing-id.html___fr",
    path: "/fr/:slug-:id(\\d+l).html",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/[landing]-[id].html.vue")
  },
  {
    name: "v2-confirm___es",
    path: "/es/v2/confirm",
    meta: confirm68nO8wcKwuXAEuUd2tk0KQZ3G9G8zBrgCXMtFhprAGEMeta || {},
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(payment)/v2/confirm.vue")
  },
  {
    name: "v2-confirm___en",
    path: "/en/v2/confirm",
    meta: confirm68nO8wcKwuXAEuUd2tk0KQZ3G9G8zBrgCXMtFhprAGEMeta || {},
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(payment)/v2/confirm.vue")
  },
  {
    name: "v2-confirm___de",
    path: "/de/v2/confirm",
    meta: confirm68nO8wcKwuXAEuUd2tk0KQZ3G9G8zBrgCXMtFhprAGEMeta || {},
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(payment)/v2/confirm.vue")
  },
  {
    name: "v2-confirm___it",
    path: "/it/v2/confirm",
    meta: confirm68nO8wcKwuXAEuUd2tk0KQZ3G9G8zBrgCXMtFhprAGEMeta || {},
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(payment)/v2/confirm.vue")
  },
  {
    name: "v2-confirm___fr",
    path: "/fr/v2/confirm",
    meta: confirm68nO8wcKwuXAEuUd2tk0KQZ3G9G8zBrgCXMtFhprAGEMeta || {},
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(payment)/v2/confirm.vue")
  },
  {
    name: "privacy.html___es",
    path: "/es/privacy.html",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(terms)/privacy.html.vue")
  },
  {
    name: "privacy.html___en",
    path: "/en/privacy.html",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(terms)/privacy.html.vue")
  },
  {
    name: "privacy.html___de",
    path: "/de/privacy.html",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(terms)/privacy.html.vue")
  },
  {
    name: "privacy.html___it",
    path: "/it/privacy.html",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(terms)/privacy.html.vue")
  },
  {
    name: "privacy.html___fr",
    path: "/fr/privacy.html",
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(terms)/privacy.html.vue")
  },
  {
    name: "recover-pass-hash___es",
    path: "/es/recover-pass/:hash()",
    meta: { ...(_91hash_939etv2tvGL9NI0gFqKCnRbx7YRujwLt7HbSknAVRJ_zMMeta || {}), ...{"middleware":["recover-pass"]} },
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(login)/recover-pass/[hash].vue")
  },
  {
    name: "recover-pass-hash___en",
    path: "/en/recover-pass/:hash()",
    meta: { ...(_91hash_939etv2tvGL9NI0gFqKCnRbx7YRujwLt7HbSknAVRJ_zMMeta || {}), ...{"middleware":["recover-pass"]} },
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(login)/recover-pass/[hash].vue")
  },
  {
    name: "recover-pass-hash___de",
    path: "/de/recover-pass/:hash()",
    meta: { ...(_91hash_939etv2tvGL9NI0gFqKCnRbx7YRujwLt7HbSknAVRJ_zMMeta || {}), ...{"middleware":["recover-pass"]} },
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(login)/recover-pass/[hash].vue")
  },
  {
    name: "recover-pass-hash___it",
    path: "/it/recover-pass/:hash()",
    meta: { ...(_91hash_939etv2tvGL9NI0gFqKCnRbx7YRujwLt7HbSknAVRJ_zMMeta || {}), ...{"middleware":["recover-pass"]} },
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(login)/recover-pass/[hash].vue")
  },
  {
    name: "recover-pass-hash___fr",
    path: "/fr/recover-pass/:hash()",
    meta: { ...(_91hash_939etv2tvGL9NI0gFqKCnRbx7YRujwLt7HbSknAVRJ_zMMeta || {}), ...{"middleware":["recover-pass"]} },
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(login)/recover-pass/[hash].vue")
  },
  {
    name: "v2-payment-return___es",
    path: "/es/v2/payment-return",
    meta: payment_45return4fMY56k_fQusi3dvoSnbOIrgdI_XJ6C6LkJdw3aGJN0Meta || {},
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(payment)/v2/payment-return.vue")
  },
  {
    name: "v2-payment-return___en",
    path: "/en/v2/payment-return",
    meta: payment_45return4fMY56k_fQusi3dvoSnbOIrgdI_XJ6C6LkJdw3aGJN0Meta || {},
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(payment)/v2/payment-return.vue")
  },
  {
    name: "v2-payment-return___de",
    path: "/de/v2/payment-return",
    meta: payment_45return4fMY56k_fQusi3dvoSnbOIrgdI_XJ6C6LkJdw3aGJN0Meta || {},
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(payment)/v2/payment-return.vue")
  },
  {
    name: "v2-payment-return___it",
    path: "/it/v2/payment-return",
    meta: payment_45return4fMY56k_fQusi3dvoSnbOIrgdI_XJ6C6LkJdw3aGJN0Meta || {},
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(payment)/v2/payment-return.vue")
  },
  {
    name: "v2-payment-return___fr",
    path: "/fr/v2/payment-return",
    meta: payment_45return4fMY56k_fQusi3dvoSnbOIrgdI_XJ6C6LkJdw3aGJN0Meta || {},
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(payment)/v2/payment-return.vue")
  },
  {
    name: "v2-one-step-check-out___es",
    path: "/es/v2/one-step-check-out",
    meta: one_45step_45check_45outJVvpgRnVMeYnhMGPCDvoQieNlF9ywuSnBXWCnz6tC6AMeta || {},
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(payment)/v2/one-step-check-out.vue")
  },
  {
    name: "v2-one-step-check-out___en",
    path: "/en/v2/one-step-check-out",
    meta: one_45step_45check_45outJVvpgRnVMeYnhMGPCDvoQieNlF9ywuSnBXWCnz6tC6AMeta || {},
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(payment)/v2/one-step-check-out.vue")
  },
  {
    name: "v2-one-step-check-out___de",
    path: "/de/v2/one-step-check-out",
    meta: one_45step_45check_45outJVvpgRnVMeYnhMGPCDvoQieNlF9ywuSnBXWCnz6tC6AMeta || {},
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(payment)/v2/one-step-check-out.vue")
  },
  {
    name: "v2-one-step-check-out___it",
    path: "/it/v2/one-step-check-out",
    meta: one_45step_45check_45outJVvpgRnVMeYnhMGPCDvoQieNlF9ywuSnBXWCnz6tC6AMeta || {},
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(payment)/v2/one-step-check-out.vue")
  },
  {
    name: "v2-one-step-check-out___fr",
    path: "/fr/v2/one-step-check-out",
    meta: one_45step_45check_45outJVvpgRnVMeYnhMGPCDvoQieNlF9ywuSnBXWCnz6tC6AMeta || {},
    component: () => import("/app/node_modules/.c12/github_ByHours_com_EqGIM1A6iS/app/pages/(payment)/v2/one-step-check-out.vue")
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/es/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/en/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/de/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/it/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/fr/sitemap.xml",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  }
]